import * as React from 'react';

export interface IAsyncLoaderState<T> {
  loading: boolean;
  data: T;
  error?: string;
}

export interface IAsyncLoaderProps<T> {
  render: (params: IAsyncLoaderState<T>) => React.ReactNode;
  load: () => Promise<T>;
}

class AsyncLoader<T> extends React.Component<
  IAsyncLoaderProps<T>,
  IAsyncLoaderState<T>
> {
  unmounted = false;

  constructor(props: IAsyncLoaderProps<T>) {
    super(props);
    this.state = {
      loading: true,
      data: null,
      error: null,
    };
  }

  componentDidMount() {
    this.props
      .load()
      .then((data: T) => {
        if (!this.unmounted) {
          this.setState({ data, loading: false });
        }
      })
      .catch((e: Error) => {
        if (!this.unmounted) {
          this.setState({ error: e.message, loading: false });
        }
      });
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  render() {
    return this.props.render(this.state);
  }
}

export default AsyncLoader;
